import { useStore } from "~/stores"

/**
 * localStorageの監視して、別タブで変更されたらそれを反映させる
 * 連続で変更されて負荷が高くならないようにlocalStorage変更後1秒後に反映させる
 */
export default defineNuxtPlugin(() => {
  let localstorageSyncTimeout: number | null = null
  let oldLocalStorageEvent: StorageEvent | null = null
  let newLocalStorageEvent: StorageEvent | null = null

  const store = useStore()

  window.addEventListener("storage", (event) => {
    if (event.key !== "root") return

    // localStorageのtimeStampを比較して、古い場合は無視する
    if (newLocalStorageEvent && newLocalStorageEvent.timeStamp >= event.timeStamp) {
      return
    }
    if (!newLocalStorageEvent) {
      // 変更前の値を保存
      oldLocalStorageEvent = event
    }
    // 最新の値を保存
    newLocalStorageEvent = event

    // すでにタイマーが起動している場合はクリアして、再度スタート
    if (localstorageSyncTimeout) {
      clearTimeout(localstorageSyncTimeout)
    }

    localstorageSyncTimeout = window.setTimeout(() => {
      if (!newLocalStorageEvent || !oldLocalStorageEvent) {
        return
      }
      const oldValue = JSON.parse(oldLocalStorageEvent.oldValue || "{}")
      const newValue = JSON.parse(newLocalStorageEvent.newValue || "{}")

      if (JSON.stringify(oldValue.cartList || []) !== JSON.stringify(newValue.cartList || [])) {
        store.cartList = newValue.cartList
      }
      // 複数タブで開いている場合、古い状態のタブがあると更新する値がundefinedになっている場合があるので、undefinedの場合は無視する
      if (newValue.duvetCollectionType !== undefined && oldValue.duvetCollectionType !== newValue.duvetCollectionType) {
        store.duvetCollectionType = newValue.duvetCollectionType
      }
      if (
        newValue.noveltyItems !== undefined &&
        JSON.stringify(oldValue.noveltyItems) !== JSON.stringify(newValue.noveltyItems)
      ) {
        store.noveltyItems = newValue.noveltyItems
      }

      oldLocalStorageEvent = null
      newLocalStorageEvent = null
      localstorageSyncTimeout = null
    }, 1000)
  })
})
